import styled from 'styled-components'

type Props = {
  variant: 'error' | 'success' | 'information' | 'warning'
  iconWidth?: number
}

const InlineAlert = styled.div<Props>`
  display: flex;
  flex-wrap: wrap;
  padding: 16px;
  border-radius: 8px;

  background-color: ${({ theme, variant }) => {
    switch (variant) {
      case 'success':
        return theme?.['-ds-success-100']?.value
      case 'error':
        return theme?.['-ds-error-100']?.value
      case 'warning':
        return theme?.['-ds-warning-100']?.value
      case 'information':
      default:
        return theme?.['-ds-information-100']?.value
    }
  }};

  color: ${({ theme, variant }) => {
    switch (variant) {
      case 'success':
        return theme?.['-ds-success-300']?.value
      case 'error':
        return theme?.['-ds-error-300']?.value
      case 'warning':
        return theme?.['-ds-warning-300']?.value
      case 'information':
      default:
        return theme?.['-ds-information-300']?.value
    }
  }};

  svg {
    width: ${({ iconWidth }) => (iconWidth ? `${iconWidth}px` : '22px')};
    max-height: ${({ iconWidth }) => (iconWidth ? `${iconWidth}px` : '22px')};
  }

  svg + * {
    width: calc(
      100% - ${({ iconWidth }) => (iconWidth ? `${iconWidth}px` : '22px')}
    );
    padding-left: 16px;
  }
`
export default InlineAlert
